import { useMemo } from 'react';

import { PatientNote, PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { SidePanelListItem } from '@dreryk/react-components';

import { NotesListItemContent } from './NotesListItemContent';
import { NotesListItemHeader } from './NotesListItemHeader';

export const useCreateNoteListItems = (
   patientId: PatientSimple['id'],
   noteData: PatientNote[] | undefined
): SidePanelListItem[] | undefined => {
   return useMemo(() => {
      if (!noteData) {
         return undefined;
      }

      return noteData.map((noteDataItem, idx) => {
         return {
            id: noteDataItem.id,
            testId: idx,
            headerContent: (
               <NotesListItemHeader
                  id={noteDataItem.id}
                  content={noteDataItem.content}
                  lastModificationDate={noteDataItem.lastModificationDate}
                  patientId={patientId}
                  createdBy={noteDataItem.createdBy}
               />
            ),
            content: <NotesListItemContent content={noteDataItem.content} />,
         };
      });
   }, [noteData, patientId]);
};
